// extracted by mini-css-extract-plugin
export default {"appWrapper":"App_appWrapper__p-V5m","appWrapperContent":"App_appWrapperContent__DdHDg"};